import { Controller } from 'stimulus'

export default class extends Controller {
  handleClick () {
    this.element.classList.toggle('spoiler_opened')
  }
}
